module.exports = __webpack_public_path__ + "static/media/reporting-help.a5356d5e.svg";